export default "__VITE_ASSET__DSKf9NWy__"